import z from "zod";

import { locale } from "@/common/locale";

export const profileSchema = z.object({
  username: z.string().min(1, locale.required).max(150, "Не более 150 символов"),
  login: z.string().min(1, locale.required).max(30),
  contactNumber: z
    .string()
    .min(1, locale.required)
    .regex(/^\+\d{11}$/, "Некорректный номер телефона"),
  email: z
    .string()
    .min(1, locale.required)
    .email("Некорректный email")
    .max(100, "Не более 100 символов"),
});

export const companySchema = z.object({
  companyName: z.string().min(1, locale.required).max(150, "Не более 150 символов"),
  inn: z
    .string()
    .min(1, locale.required)
    .regex(/^\d{10}$|^\d{12}$/, "Поле должно содержать 10 или 12 цифр"),
  kpp: z
    .string()
    .min(1, locale.required)
    .regex(/^\d{9}$/, "Поле должно содержать 9 цифр"),
  ogrn: z
    .string()
    .min(1, locale.required)
    .regex(/^\d{13}$|^\d{15}$/, "Поле должно содержать 13 или 15 цифр"),
  contactNumber: z
    .string()
    .min(1, locale.required)
    .regex(/^\+\d{11}$/, "Некорректный номер телефона"),
  companyEmail: z
    .string()
    .min(1, locale.required)
    .email("Некорректный email")
    .max(100, "Не более 100 символов"),
  addressLegal: z.string().min(1, locale.required).max(255, "Не более 255 символов"),
  addressActual: z.string().min(1, locale.required).max(255, "Не более 255 символов"),
  id: z.string(),
});
